import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  gap: ${theme.spacing.xm};
`

export const Header = styled.div`
  width: 100%;
  padding: ${theme.spacing.xm} ${theme.spacing.md};
  background-color: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.xm};
`

export const TitleContainer = styled.div`
  display: flex;
`

export const Title = styled.h1`
  font-size: ${theme.typography.sizes['2md']};
  color: ${theme.colors.neutral.black};
  margin: 0;
`

export const Form = styled('form')`
  background-color: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  margin-bottom: 16px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
  margin: 24px 0;
`

export const FieldsContainer = styled.div`
  display: grid;
  gap: ${theme.spacing.sm};
  margin-bottom: 16px;
  justify-content: left;
`

type FieldWrapperProps = {
  templateColumns: string
  mediaTemplateColumns?: string
}

export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: grid;
  grid-template-columns: ${(props) => props.templateColumns};
  gap: ${theme.spacing.sm} ${theme.spacing.md};
  width: 100%;

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: ${({ templateColumns, mediaTemplateColumns }) =>
      mediaTemplateColumns ? mediaTemplateColumns : templateColumns};
  }
`

export const FieldItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const LabelFilter = styled.div`
  display: flex;
  color: ${theme.colors.neutral.high};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['2xs']};
  gap: ${theme.spacing.xs};
  align-items: center;
  white-space: nowrap;
  font-family: ${theme.typography.family.bold};
`

export const FormActionsContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${theme.spacing.sm};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  padding: 24px 0;
`

export const TextInfo = styled.h5`
  font-size: ${theme.typography.sizes['2xs']};
  color: ${theme.colors.neutral[50]};
  font-weight: ${theme.typography.weight.lg};
  margin: 0;
`
